export default "__VITE_ASSET__3c93bb72__"